var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _g3, _path11, _path12, _path13, _g4, _path14, _path15, _path16, _g5, _path17, _g6, _path18, _path19, _path20, _g7, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 91,
    viewBox: "0 0 117 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3780_19537)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1905 0C15.1905 0 43.6131 9.4351 44.887 9.91283C46.161 10.3906 51.9009 17.238 51.9009 17.238C51.9009 17.238 54.76 18.6313 57.6662 18.6313C60.5724 18.6313 62.4037 17.238 62.4037 17.238C67.0885 13.64 69.525 11.814 74.6653 9.03699L87.4843 4.45878L100.307 0L110.853 6.92704L67.0074 79.0239L57.7493 81.7476L45.8908 79.0239L4.95703 6.92704L15.1905 0Z",
    fill: "#624E17"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 19,
    width: 15,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.623 19.627H64.5879V24.8906H50.623V19.627Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 19,
    width: 15,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.409 19.8364L50.7012 22.8065C51.4498 23.2685 52.8379 24.0074 54.638 24.4522C58.0465 25.2944 61.3682 24.7551 64.522 22.8497L62.802 19.7051C58.2593 21.9622 53.7077 20.3798 52.409 19.8364Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 19,
    width: 15,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.409 19.8364L50.7012 22.8065C51.4498 23.2685 52.8379 24.0074 54.638 24.4522C58.0465 25.2944 61.3682 24.7551 64.522 22.8497L62.802 19.7051C58.2593 21.9622 53.7077 20.3798 52.409 19.8364Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3780_19537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.522 19.7051H50.7012V25.2944H64.522V19.7051Z",
    fill: "url(#paint0_linear_3780_19537)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 0,
    width: 43,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.832 0.504883H105.189V19.0888H63.832V0.504883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 0,
    width: 43,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.086 1.94821L92.4468 5.03868L100.871 1.30997C100.267 0.993163 99.7494 0.719154 99.4049 0.536621C99.1158 0.635231 98.702 0.777061 98.1909 0.95246C97.9115 1.08422 97.7386 1.1522 97.7008 1.16604L97.6849 1.12534C92.9357 2.75471 81.7693 6.60048 77.1783 8.31084C72.2054 10.1639 65.4509 15.3809 63.9062 16.6037L63.9386 16.9205L65.0933 19.0324C69.592 16.1039 97.8019 6.08058 105.095 3.51211C104.22 3.06396 103.117 2.48825 102.086 1.94821Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 0,
    width: 43,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.084 1.94723L92.4449 5.0377L100.869 1.309C100.265 0.992186 99.7474 0.718177 99.4029 0.535645C99.1138 0.634254 98.7001 0.776084 98.189 0.951483C97.9095 1.08324 97.7366 1.15122 97.6989 1.16507L97.6829 1.12437C92.9337 2.75373 81.7673 6.59951 77.1763 8.30986C72.2035 10.1629 65.4489 15.38 63.9043 16.6027L63.9366 16.9195L65.0914 19.0315C69.5901 16.103 97.8 6.0796 105.093 3.51114C104.218 3.06299 103.115 2.48728 102.084 1.94723Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3780_19537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.093 0.535645H63.9043V19.0315H105.093V0.535645Z",
    fill: "url(#paint1_linear_3780_19537)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 46,
    height: 18
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86133 4.26514H49.6561V21.9897H4.86133V4.26514Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 46,
    height: 18
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6059 20.0253L9.4122 4.33545L4.9668 7.2929L48.5254 21.9064L49.6059 20.0253Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 46,
    height: 18
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6079 20.0258L9.41416 4.33594L4.96875 7.29339L48.5273 21.9069L49.6079 20.0258Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3780_19537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6079 4.33594H4.96875V21.9069H49.6079V4.33594Z",
    fill: "url(#paint2_linear_3780_19537)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 41,
    height: 20
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5547 0.396484H50.9452V19.0878H10.5547V0.396484Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 41,
    height: 19
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8685 10.884C41.71 8.81828 26.8582 4.02627 17.4491 1.16659V1.16785L17.4395 1.1645C16.6485 0.924056 15.8957 0.697463 15.192 0.486816L12.9341 1.98946L23.3003 6.16505L11.7806 2.75652L10.5977 3.54288L50.1934 18.9998L50.8753 17.814C50.509 15.6878 48.2984 13.1261 44.8685 10.884Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 41,
    height: 20
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8685 10.885C41.71 8.81926 26.8582 4.02725 17.4491 1.16757V1.16883L17.4395 1.16547C16.6485 0.925032 15.8957 0.69844 15.192 0.487793L12.9341 1.99044L23.3003 6.16603L11.7806 2.75749L10.5977 3.54385L50.1934 19.0008L50.8753 17.815C50.509 15.6888 48.2984 13.127 44.8685 10.885Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3780_19537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8753 0.487793H10.5977V19.0008H50.8753V0.487793Z",
    fill: "url(#paint3_linear_3780_19537)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 4,
    width: 46,
    height: 18
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6602 4.15723H110.025V21.8818H65.6602V4.15723Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 4,
    width: 46,
    height: 18
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6602 20.0598L66.6303 21.8344C69.3855 20.6955 77.6108 17.3302 86.3816 14.0354C97.4762 9.86861 105.387 7.32909 110.003 6.44706C108.628 5.51803 107.252 4.6188 106.547 4.24072C93.432 8.83425 69.0771 17.676 65.6602 20.0598Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 4,
    width: 46,
    height: 18
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6602 20.0593L66.6303 21.8339C69.3855 20.695 77.6108 17.3297 86.3816 14.0349C97.4762 9.86812 105.387 7.3286 110.003 6.44657C108.628 5.51754 107.252 4.61831 106.547 4.24023C93.432 8.83377 69.0771 17.6755 65.6602 20.0593Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_3780_19537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.003 4.24023H65.6602V21.8339H110.003V4.24023Z",
    fill: "url(#paint4_linear_3780_19537)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 8,
    width: 48,
    height: 72
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6602 8.4541H112.603V79.8895H65.6602V8.4541Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_3780_19537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1777 79.5466C67.8028 78.5337 74.1243 76.1955 76.8069 75.6702C76.1729 72.9989 75.6962 69.9269 75.6962 66.3229C75.6962 59.9485 77.981 54.0789 82.131 49.7951C84.1934 47.6659 86.6188 46.0194 89.2788 44.9082C87.6414 42.9587 84.809 38.3051 86.3964 30.6686C87.1161 27.2105 89.5452 24.5124 93.2349 23.0727C97.7093 21.3262 103.384 21.641 107.435 23.7294L112.109 8.23047C105.087 8.55819 78.2861 19.1145 67.0425 23.7764L65.1777 79.5466Z",
    fill: "#FF5F3D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 24,
    width: 16,
    height: 59
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3164 24.6543H65.3554V82.1248H50.3164V24.6543Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 25,
    width: 16,
    height: 58
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9712 26.6962C52.4468 26.3097 51.1846 25.7478 50.2715 25.259L52.0439 80.7519L56.935 82.5705L63.3039 80.5631L65.1569 25.1826C62.4617 26.6748 59.9029 27.167 57.7008 27.167C56.2913 27.167 55.0291 26.966 53.9712 26.6962Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_3780_19537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_3780_19537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 25,
    width: 16,
    height: 58
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9712 26.6967C52.4468 26.3102 51.1846 25.7483 50.2715 25.2595L52.0439 80.7524L56.935 82.571L63.3039 80.5635L65.1569 25.1831C62.4617 26.6753 59.9029 27.1675 57.7008 27.1675C56.2913 27.1675 55.0291 26.9665 53.9712 26.6967Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_3780_19537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1761 24.6548H50.3164L51.0985 80.1833C51.0985 80.1833 53.8358 81.7474 56.9642 81.7474C60.0925 81.7474 63.2209 80.1833 63.2209 80.1833L65.1761 24.6548Z",
    fill: "#FF5F3D"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72986 10.9292C2.26059 10.4261 47.7563 23.818 47.7563 23.818L48.9317 79.9501L15.2043 66.0726C15.2043 66.0726 7.19913 11.4323 4.72986 10.9292Z",
    fill: "#FF5F3D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.529 8.83057L67.3016 24.3549L64.4973 80.3793L98.7461 67.429L111.529 8.83057Z",
    fill: "#FF5F3D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4074 67.879L60.4226 69.0894C60.4239 69.1966 60.394 69.2873 60.3329 69.3615C60.266 69.43 60.1903 69.4705 60.1058 69.4828L54.7236 70.3294L54.6982 70.3297C54.6474 70.3304 54.6049 70.314 54.5706 70.2805C54.5306 70.2415 54.5103 70.1966 54.5097 70.1459L54.4899 68.5714C54.4875 68.3852 54.5624 68.2827 54.7146 68.2638L57.098 67.946L56.0355 67.6123C55.8712 67.5579 55.7882 67.463 55.7864 67.3275L55.7756 66.4641C55.7739 66.3287 55.8545 66.2317 56.0174 66.1733L57.0627 65.813L54.6805 65.5551C54.5279 65.5401 54.4505 65.4395 54.4481 65.2533L54.4283 63.6788C54.4277 63.628 54.4469 63.5855 54.486 63.5511C54.5193 63.5112 54.5614 63.4909 54.6122 63.4903L54.6376 63.4899L60.0394 64.2009C60.1242 64.2111 60.2009 64.2525 60.2695 64.325C60.3325 64.3919 60.3646 64.479 60.366 64.5862L60.3812 65.7967C60.3834 65.9716 60.3087 66.0882 60.157 66.1466L58.4305 66.8625L60.1745 67.5348C60.3275 67.5893 60.4052 67.704 60.4074 67.879ZM58.4329 63.0195L57.8573 63.0267C57.214 63.0348 56.7174 62.8125 56.3674 62.3597C56.0174 61.907 55.8379 61.3194 55.8288 60.5971C55.8197 59.8748 55.9844 59.2829 56.3229 58.8215C56.6614 58.3601 57.1523 58.1253 57.7956 58.1172L58.3712 58.11C59.0201 58.1018 59.5195 58.3157 59.8693 58.7515C60.2134 59.1874 60.3902 59.7834 60.3997 60.5396C60.4092 61.2958 60.2475 61.8961 59.9144 62.3405C59.5757 62.785 59.0819 63.0113 58.4329 63.0195ZM58.465 60.183L57.7539 60.1919C57.5395 60.1946 57.3903 60.2247 57.3064 60.2822C57.2224 60.3397 57.1814 60.439 57.1831 60.5801C57.1849 60.7212 57.2285 60.8194 57.3138 60.8747C57.3992 60.9301 57.5491 60.9564 57.7635 60.9537L58.4746 60.9448C58.7003 60.942 58.8523 60.9118 58.9306 60.8544C59.0089 60.797 59.0471 60.6977 59.0454 60.5567C59.0436 60.4156 59 60.3174 58.9147 60.262C58.8293 60.2066 58.6794 60.1803 58.465 60.183ZM58.3658 57.6834L57.7902 57.6907C57.1469 57.6988 56.6502 57.4764 56.3003 57.0237C55.9503 56.5709 55.7708 55.9834 55.7617 55.2611C55.7526 54.5387 55.9173 53.9469 56.2558 53.4854C56.5942 53.024 57.0851 52.7893 57.7285 52.7812L58.3041 52.7739C58.953 52.7658 59.4524 52.9796 59.8022 53.4154C60.1463 53.8513 60.3231 54.4474 60.3326 55.2036C60.3421 55.9597 60.1803 56.56 59.8473 57.0045C59.5086 57.449 59.0148 57.6753 58.3658 57.6834ZM58.3979 54.8469L57.6868 54.8559C57.4724 54.8586 57.3232 54.8887 57.2393 54.9462C57.1553 55.0037 57.1142 55.1029 57.116 55.244C57.1178 55.3851 57.1614 55.4833 57.2467 55.5387C57.3321 55.5941 57.482 55.6204 57.6964 55.6177L58.4074 55.6087C58.6332 55.6059 58.7852 55.5758 58.8635 55.5184C58.9418 55.4609 58.98 55.3617 58.9783 55.2206C58.9765 55.0795 58.9329 54.9813 58.8476 54.9259C58.7622 54.8706 58.6123 54.8442 58.3979 54.8469ZM57.6085 47.2849L58.2773 47.2765C58.9431 47.2681 59.439 47.4284 59.7649 47.7573C60.0851 48.0863 60.2485 48.5188 60.2553 49.0549C60.262 49.591 60.0782 50.0081 59.7038 50.3063L59.9577 50.3031C60.0198 50.3024 60.0737 50.3243 60.1194 50.3688C60.1651 50.4134 60.1884 50.4667 60.1891 50.5288L60.2072 51.9678C60.208 52.0299 60.1861 52.0838 60.1416 52.1295C60.097 52.1752 60.0436 52.1984 59.9816 52.1992L54.4287 52.2691C54.3667 52.2699 54.3128 52.248 54.2671 52.2034C54.2213 52.1588 54.1981 52.1055 54.1973 52.0434L54.1776 50.4774C54.1768 50.4154 54.1987 50.3615 54.2433 50.3157C54.2879 50.27 54.3412 50.2468 54.4033 50.246L56.0962 50.2247C55.8273 49.9346 55.6898 49.5469 55.6837 49.0616C55.6775 48.5706 55.8388 48.1538 56.1675 47.811C56.4962 47.4682 56.9765 47.2929 57.6085 47.2849ZM58.2632 50.1975C58.5905 50.1933 58.7524 50.0502 58.7488 49.7681C58.7453 49.4859 58.5798 49.3469 58.2525 49.351L57.6939 49.358C57.3666 49.3621 57.2047 49.5053 57.2082 49.7874C57.2116 50.0527 57.3544 50.192 57.6368 50.2053L58.2632 50.1975ZM60.1191 44.9595L60.1382 46.4747C60.1389 46.5368 60.117 46.5907 60.0725 46.6364C60.0279 46.6821 59.9746 46.7053 59.9125 46.7061L54.3597 46.776C54.2976 46.7767 54.2437 46.7548 54.198 46.7103C54.1523 46.6657 54.129 46.6124 54.1282 46.5503L54.1092 45.0351C54.1084 44.973 54.1303 44.9191 54.1749 44.8734C54.2194 44.8277 54.2728 44.8045 54.3348 44.8037L59.8877 44.7338C59.9498 44.7331 60.0036 44.755 60.0494 44.7995C60.0951 44.8441 60.1183 44.8974 60.1191 44.9595ZM60.0858 42.31L60.1048 43.8252C60.1056 43.8873 60.0837 43.9411 60.0391 43.9869C59.9946 44.0326 59.9412 44.0558 59.8792 44.0566L54.3263 44.1264C54.2643 44.1272 54.2104 44.1053 54.1646 44.0607C54.1189 44.0162 54.0957 43.9628 54.0949 43.9008L54.0758 42.3856C54.0751 42.3235 54.097 42.2696 54.1415 42.2239C54.1861 42.1782 54.2394 42.1549 54.3015 42.1542L59.8544 42.0843C59.9164 42.0835 59.9703 42.1054 60.016 42.15C60.0617 42.1946 60.085 42.2479 60.0858 42.31ZM55.6738 41.5442L55.6558 40.1137C55.6542 39.9839 55.7208 39.8928 55.8556 39.8403L57.7768 39.1219L55.8378 38.4267C55.7016 38.3719 55.6327 38.2768 55.631 38.1414L55.6132 36.7278C55.6126 36.677 55.6318 36.6316 55.6708 36.5916C55.7041 36.5517 55.7406 36.5315 55.7801 36.531C55.8196 36.5305 55.8507 36.5329 55.8733 36.5383L61.4477 38.8556C61.5838 38.9103 61.6528 39.0082 61.6546 39.1493L61.672 40.5375C61.6727 40.5883 61.6563 40.6337 61.6229 40.6736C61.5895 40.7079 61.5474 40.7253 61.4966 40.726C61.4515 40.7265 61.4232 40.7241 61.4119 40.7186L59.7781 40.0618L55.9388 41.7441C55.9219 41.7499 55.9022 41.753 55.8796 41.7533C55.7439 41.7324 55.6753 41.6627 55.6738 41.5442Z",
    fill: "#FFF8E8",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3780_19537",
    x: 0.422589,
    y: 0,
    width: 115.897,
    height: 90.168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.21022
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.10511
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3780_19537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3780_19537",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3780_19537",
    x1: 57.6116,
    y1: 19.7053,
    x2: 57.6116,
    y2: 25.2944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#F3F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EEEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EDEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#E8E9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#E6E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#E4E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E3E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#E2E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#E0E0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#DEDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DADAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#D5D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D2D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#CDCECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#CCCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#CBCCC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3780_19537",
    x1: 84.498,
    y1: 0.535561,
    x2: 84.498,
    y2: 19.0314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#F3F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#F2F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#EBECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E3E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#E3E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E2E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#E2E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#DFE0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#DADAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D8D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D6D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CBCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3780_19537",
    x1: 27.2879,
    y1: 4.33587,
    x2: 27.2879,
    y2: 21.9068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#F3F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#F2F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#EBECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E3E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#E3E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E2E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#E1E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#DFE0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#DADAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D8D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D6D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CBCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3780_19537",
    x1: 30.737,
    y1: 0.487759,
    x2: 30.737,
    y2: 19.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#F3F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#F2F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#EBECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E3E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#E3E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E2E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#E1E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#DFE0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#DADAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D8D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D6D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#CCCCCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CBCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3780_19537",
    x1: 87.832,
    y1: 4.24034,
    x2: 87.832,
    y2: 21.8338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F5F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#F3F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#F2F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0F1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#ECEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ECEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#ECEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#ECEDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EBECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#EBECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EAEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E7E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E7E8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E6E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E5E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#E4E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E3E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#E3E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E2E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E2E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#E1E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E1E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E0E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#DFE0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#DFDFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#DDDDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#DCDDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#DCDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#DBDCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#DBDBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#DADAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D9DAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D9D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#D8D8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D8D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D7D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D6D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D6D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D5D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D4D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D3D4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D2D3D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#D1D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#D1D2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CFD0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#CECECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#CDCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CCCDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#CCCCCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#CBCCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#CBCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#CACAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#C9C9C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#C8C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#C7C8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#C7C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#C6C6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#C6C6C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#C5C5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#C4C4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#C3C3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book-icon.d31313b525a10d99c9042d5577090d37.svg";
export { ForwardRef as ReactComponent };